import { Routes } from '@angular/router';

import { ContractDetailComponent } from 'app/admin/contracts/admin-contract-detail.component';
import { AdminContractsComponent } from 'app/admin/contracts/admin-contracts.component';
import { ExportConfigurationsComponent } from 'app/admin/export/configurations/export-configurations.component';
import { FcdtoNcisComponent } from 'app/admin/export/fcdtoncis/fcdtoncis.component';
import { ExportMstComponent } from 'app/admin/export/mst/export-mst.component';
import { ExportOthersComponent } from 'app/admin/export/others/export-others.component';
import { ImportCsvComponent } from 'app/admin/import/csv/import-csv.component';
import { ImportFcdComponent } from 'app/admin/import/fcd/import-fcd.component';
import { ImportShapesComponent } from 'app/admin/import/shapes/import-shapes.component';
import { AdminLocationsOverviewComponent } from 'app/admin/locations/admin-locations-overview.component';
import { MaintenanceComponent } from 'app/admin/maintenance/maintenance.component';
import { OsmVersionComponent } from 'app/admin/osm-version/osm-version.component';
import { TaskComponent } from 'app/admin/tasks/task.component';
import { AdminUserDetailComponent } from 'app/admin/users/admin-user-detail.component';
import { AdminUsersComponent } from 'app/admin/users/admin-users.component';
import { ContractsComponent } from 'app/contracts/contracts.component';
import { AuthGuard } from 'app/guards/auth.guard';
import { RoleApplicationAdminGuard } from 'app/guards/role-application-admin.guard';
import { RoleLocationAdminGuard } from 'app/guards/role-location-admin.guard';
import { RoleLocationOrMapAdminGuard } from 'app/guards/role-location-or-map-admin.guard';
import { RoleMapAdminGuard } from 'app/guards/role-map-admin.guard';
import { LinearDetailsComponent } from 'app/locations/details/linear/linear-details.component';
import { PointDetailsComponent } from 'app/locations/details/point/point-details.component';
import { LinearInsertComponent } from 'app/locations/insert/linear/linear-insert.component';
import { PointInsertComponent } from 'app/locations/insert/point/point-insert.component';
import { LocationsComponent } from 'app/locations/locations.component';
import { LoginKeycloakCallbackComponent } from 'app/login-keycloak-callback/login-keycloak-callback.component';
import { LoginKeycloakComponent } from 'app/login-keycloak/login-keycloak.component';
import { LogoutKeycloakComponent } from 'app/logout-keycloak/logout-keycloak.component';
import { PageNotFoundComponent } from 'app/pagenotfound.component';
import { VildVersionComponent } from 'app/vildversion/vild-version.component';

export const appRoutes: Routes = [
  {
    path: 'admin/contracts',
    component: AdminContractsComponent,
    canActivate: [AuthGuard, RoleApplicationAdminGuard]
  },
  {
    path: 'admin/contracts/detail/:id',
    component: ContractDetailComponent,
    canActivate: [AuthGuard, RoleApplicationAdminGuard]
  },
  {
    path: 'admin/contracts/new',
    component: ContractDetailComponent,
    canActivate: [AuthGuard, RoleApplicationAdminGuard]
  },
  {
    path: 'admin/export/mst',
    component: ExportMstComponent,
    canActivate: [AuthGuard, RoleLocationOrMapAdminGuard]
  },
  {
    path: 'admin/export/fcdtoncis',
    component: FcdtoNcisComponent,
    canActivate: [AuthGuard, RoleMapAdminGuard]
  },
  {
    path: 'admin/export/others',
    component: ExportOthersComponent,
    canActivate: [AuthGuard, RoleLocationAdminGuard]
  },
  {
    path: 'admin/export/configurations',
    component: ExportConfigurationsComponent,
    canActivate: [AuthGuard, RoleLocationAdminGuard]
  },
  {
    path: 'admin/import/csv',
    component: ImportCsvComponent,
    canActivate: [AuthGuard, RoleMapAdminGuard]
  },
  {
    path: 'admin/import/shapes',
    component: ImportShapesComponent,
    canActivate: [AuthGuard, RoleMapAdminGuard]
  },
  {
    path: 'admin/import/fcd',
    component: ImportFcdComponent,
    canActivate: [AuthGuard, RoleMapAdminGuard]
  },
  {
    path: 'admin/locations',
    component: AdminLocationsOverviewComponent,
    canActivate: [AuthGuard, RoleLocationAdminGuard]
  },
  {
    path: 'admin/maintenance',
    component: MaintenanceComponent,
    canActivate: [AuthGuard, RoleApplicationAdminGuard]
  },
  {
    path: 'admin/osm',
    component: OsmVersionComponent,
    canActivate: [AuthGuard, RoleMapAdminGuard]
  },
  {
    path: 'admin/tasks',
    component: TaskComponent,
    canActivate: [AuthGuard, RoleLocationOrMapAdminGuard]
  },
  {
    path: 'admin/users',
    component: AdminUsersComponent,
    canActivate: [AuthGuard, RoleApplicationAdminGuard]
  },
  {
    path: 'admin/users/detail/:id',
    component: AdminUserDetailComponent,
    canActivate: [AuthGuard, RoleApplicationAdminGuard]
  },
  {
    path: 'admin/users/new',
    component: AdminUserDetailComponent,
    canActivate: [AuthGuard, RoleApplicationAdminGuard]
  },
  {
    path: 'admin/vildversions',
    component: VildVersionComponent,
    canActivate: [AuthGuard, RoleLocationOrMapAdminGuard]
  },
  {
    path: 'contracts',
    component: ContractsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'location/:contractId/linear/new',
    component: LinearInsertComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'location/:contractId/linear/new/:lat/:lng',
    component: LinearInsertComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'location/:contractId/point/new',
    component: PointInsertComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'location/:contractId/point/new/:lat/:lng',
    component: PointInsertComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'location/linear/:action/:locationId',
    component: LinearDetailsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'location/linear/detail/:locationId',
    component: LinearDetailsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'location/point/:action/:locationId',
    component: PointDetailsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'location/point/detail/:locationId',
    component: PointDetailsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'locations/:contractId',
    component: LocationsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    component: LoginKeycloakComponent
  },
  {
    path: 'logout',
    component: LogoutKeycloakComponent
  },
  {
    path: 'keycloak-login-callback',
    component: LoginKeycloakCallbackComponent
  },
  {
    path: 'page-not-found',
    component: PageNotFoundComponent
  },
  {
    path: '**',
    component: LoginKeycloakComponent
  }
];



// WEBPACK FOOTER //
// ./src/app/app.routing.ts